import React from 'react';
import {
  Label,
  Variant,
  Palette,
} from '@havenengineering/module-shared-library/dist/components/Label';
import styles from './availability-label.module.scss';

type Props = {
  availabilityLabel?: string;
};

export const AvailabilityLabel = ({ availabilityLabel }: Props) => (
  <div className={styles.availabilityLabel}>
    <Label
      text={availabilityLabel || ''}
      palette={Palette.VIVID_PINK}
      variant={Variant.TEXT_ONLY}
      uppercase={false}
    />
  </div>
);
